import { useState, useCallback } from 'react';
import { FormModeEnum } from '@project-types/FormModeEnum';
import OrderCatForm from '@pages/order-cat/OrderCatForm';
import OrderCatSummary from '@pages/order-cat/OrderCatSummary';



const OrderCat = () => {

	const [ formMode, setFormMode ] = useState<FormModeEnum>(FormModeEnum.form);


	const goToSummary = useCallback(() => {
		setFormMode(FormModeEnum.summary);
	},[]);


	const goToForm = useCallback(() => {
		setFormMode(FormModeEnum.form);
	},[]);


	return (
		<div className="app-page order-page cat-order-page">
			
			{formMode === FormModeEnum.form &&
				<OrderCatForm goToSummary={goToSummary} />}
			
			{formMode === FormModeEnum.summary &&
				<OrderCatSummary goToForm={goToForm} />}

		</div>
	);
};

export default OrderCat;